export const customerPasswordRegExp = /(?=.*[A-Z])(?=.*[a-z])(?!.*\s).{6,}/;
export const invalidPasswordMsg = 'The password must be at least 6 characters long and must contain at least: 1 uppercase letter and 1 lowercase letter';
